import { createSlice } from '@reduxjs/toolkit';
import { stackAndShipApiSlice } from './stack-and-ship-apiSlice';
interface StackAndShipState {
  isPending: boolean;
}

const initialState: StackAndShipState = {
  isPending: false
};

const stackAndShipSlice = createSlice({
  name: 'stackAndShip',
  initialState,
  reducers: {
    setIsPending: (state, action) => {
      state.isPending = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(stackAndShipApiSlice.endpoints.createRequestItem.matchPending, (state) => {
      state.isPending = true;
    });
    builder.addMatcher(stackAndShipApiSlice.endpoints.createRequestItem.matchFulfilled, (state) => {
      state.isPending = false;
    });
    builder.addMatcher(stackAndShipApiSlice.endpoints.createRequestItem.matchRejected, (state) => {
      state.isPending = false;
    });
    builder.addMatcher(stackAndShipApiSlice.endpoints.updateRequestItem.matchPending, (state) => {
      state.isPending = true;
    });
    builder.addMatcher(stackAndShipApiSlice.endpoints.updateRequestItem.matchFulfilled, (state) => {
      state.isPending = false;
    }); 
    builder.addMatcher(stackAndShipApiSlice.endpoints.updateRequestItem.matchRejected, (state) => {  
      state.isPending = false;
    });
    builder.addMatcher(stackAndShipApiSlice.endpoints.saveChosenCases.matchPending, (state) => {
      state.isPending = true;
    });
    builder.addMatcher(stackAndShipApiSlice.endpoints.saveChosenCases.matchFulfilled, (state) => {
      state.isPending = false;
    });
    builder.addMatcher(stackAndShipApiSlice.endpoints.saveChosenCases.matchRejected, (state) => {
      state.isPending = false;
    });
    builder.addMatcher(stackAndShipApiSlice.endpoints.updateChosenCases.matchPending, (state) => {
      state.isPending = true;
    });
    builder.addMatcher(stackAndShipApiSlice.endpoints.updateChosenCases.matchFulfilled, (state) => {
      state.isPending = false;
    });
    builder.addMatcher(stackAndShipApiSlice.endpoints.updateChosenCases.matchRejected, (state) => {
      state.isPending = false;
    });
    // builder.addMatcher(stackAndShipApiSlice.endpoints.updateNewChosenCases.matchPending, (state) => {
    //   state.isPending = true;
    // });
    // builder.addMatcher(stackAndShipApiSlice.endpoints.updateNewChosenCases.matchFulfilled, (state) => {
    //   state.isPending = false;
    // });
    // builder.addMatcher(stackAndShipApiSlice.endpoints.updateNewChosenCases.matchRejected, (state) => {
    //   state.isPending = false;
    // });


  }
});

export const { setIsPending } = stackAndShipSlice.actions;
export default stackAndShipSlice.reducer;
